import Mock from 'mockjs'
import '@/mock/hami-computility'


Mock.setup({
    timeout: '300-600'
})
